import Constant from '@/common/constant/Constant';
import { TextField } from '@material-ui/core';
import Utils from '@/common/utils/utils';
import EmailMultiChoiceInput from '../../../../project/EmailResponseSetting/EmailMultiChoiceInput';
import TextInputWithChip from '@/component/formManagement/allFieldItem/TextInputWithChip';


export default function ReplyEmailInput({
    detailTicket,
    fieldData,
    replyToEmailTicket,
    toEmailAddressList,
    setToEmailAddressList,
    ccEmailAddressList,
    setCcEmailAddressList,
    bccEmailAddressList,
    setBccEmailAddressList,
    listSuggestSearchEmail,
    fromSysFieldData,
    currentEmailTicket,
    triggerEnableBtnSaveTicket
}) {

    // return component for reply to email
    let isSysFieldTextInputWithChip = [Constant.SYS_FIELD.TO, Constant.SYS_FIELD.CC, Constant.SYS_FIELD.BCC];
    if (isSysFieldTextInputWithChip.includes(fieldData.sysField)) {
        
        let props = {
            ...fieldData,
            detailTicket,
            data: fieldData,
            toEmailAddressList,
            setToEmailAddressList,
            ccEmailAddressList,
            setCcEmailAddressList,
            bccEmailAddressList,
            setBccEmailAddressList,
            label: fieldData?.name?.jp?.text
        }

        return  (
            <TextInputWithChip 
                {...props} 
                setIsEdited={() => {}} 
                listSuggestSearchEmail={listSuggestSearchEmail} 
                triggerEnableBtnSaveTicket={triggerEnableBtnSaveTicket}
        />)

    }

    let isArrayData = Array.isArray(fieldData.value);
    if (isArrayData) {
        return (
            <div className='form-addTicket'>
                <div className="cell-prod-status gap-8"><label class="form-addTicket-label">{fieldData?.name?.jp?.text}</label></div>
                <div className="email-response-address-input-wrap" style={{width: '100%'}}>
                    <EmailMultiChoiceInput
                        disable={true}
                        addressList={fieldData.value}
                    />
                </div>
            </div>
        )
    }

    return (
        <div className='form-addTicket'>
            <div className="cell-prod-status gap-8"><label class="form-addTicket-label">{fieldData?.name?.jp?.text}</label></div>
            <TextField
                fullWidth
                variant="outlined"
                className="form-control-wrapInput form-control-hg40 email-response-address-input"
                value={Utils.isEmptyObject(fieldData.value) ? '' : fieldData.value }
                disabled={true}
            />
        </div>
    );
}
